import { baseTheme } from './baseTheme';

export const darkTheme = {
  ...baseTheme,
  colors: {
    white: '#fff',
    white2: '#5d6569',
    black: '#d1cdc7',
    red: '#FF6B6B',
    red2: '#FF4D4D',
    red3: '#444444',
    gray: '#DCDCDC',
    gray2: '#AAAAAA',
    gray3: '#999999',
    gray4: '#888888',
    gray5: '#3a3f41',
    gray6: 'rgba(255, 255, 255, 0.2)',
    gray7: '#333333',
    gray8: '#25282a',
    gray9: '#5d6569',
    gray10: '#FAF8F8',
    blue: '#8299FF',
    blue2: '#4D66FF',
    blue3: '#3E4A80',
    blue4: '#1C264F',
  },
  backgrounds: {
    white: '#1A1A1A',
    black: '#0F0F0F',
    gray: '#1E1E1E',
    gray2: '#a8a095',
    gray3: '#3A3A3A',
    gray4: '#4A4A4A',
    gray5: '#3a3f41',
    gray6: 'rgba(24, 26, 27, 0.3)',
    gray7: '#1f2223',
    gray8: '#25282a',
    gray9: '#5d6569',
    gray10: '#221818',
    red: '#7F1C1C',
    red2: '#FF4D4D',
    red3: '#5A1C1C',
    blue: '#0902a6',
    blue2: '#09122E',
    blue3: '#2A3D7C',
    blue4: '#FFFFFF',
  },

  border: {
    very_small: '1px solid #3a3f41',
    very_small_gray: '1px solid #3a3f41',
    very_small_gray5: '1px solid #3a3f41',
    very_small_red2: '1px solid #C51F2A',
    very_small_blue: '1px solid #0B02C1',
    small: '1.5px solid #3a3f41',
    large: '2px solid #3a3f41',
    very_large: '3px solid #3a3f41',
    small_red2: '1.5px solid #C51F2A',
    large_red2: '3px solid #3a3f41',
    small_blue: '1.5px solid #0B02C1',
    small_gray4: '1.5px solid #3a3f41',
    very_small_gray4: '1px solid #3a3f41',
  },
};
